import type { UserPreferenceLocation } from '@cognite/apm-client';
import type { Discipline } from '@cognite/apm-config';

import type { InFieldCDMLocationConfig } from '../../../features/app-config/cdm-types';
import type { DisciplineOption } from '../../../features/app-config/hooks/use-configured-disciplines';

/**
 * Gets discipline options for a given location.
 * @param allLocationConfigs List of all location configurations.
 * @param location The selected user location preference.
 * @returns Array of discipline options for the specified location, or empty array if no location provided.
 */
export const getDisciplineOptionsForLocation = (
  allLocationConfigs: InFieldCDMLocationConfig[],
  location?: UserPreferenceLocation
) => {
  if (!location) return [];

  const locationConfig = allLocationConfigs.find(
    (config) =>
      config.externalId === location.externalId &&
      config.space === location.space
  );

  const configuredDisciplines: Discipline[] = locationConfig?.disciplines || [];

  const disciplineOptions: DisciplineOption[] = configuredDisciplines.map(
    (discipline) => ({
      label: discipline.name,
      value: discipline,
    })
  );

  return disciplineOptions;
};
